import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <main
    className="flex flex-col items-center justify-center min-h-screen"
    style={{ backgroundColor: "#0B0E13" }}
  >
    {/* Glow */}
    <div
      style={{
        position: "absolute",
        top: "20%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "500px",
        height: "400px",
        background: "radial-gradient(ellipse, rgba(48,166,156,0.1) 0%, transparent 65%)",
        pointerEvents: "none",
      }}
    />

    <section
      className="w-full max-w-sm p-10 flex flex-col items-center relative z-10"
      style={{
        backgroundColor: "rgba(13,17,23,0.85)",
        border: "1px solid rgba(255,255,255,0.1)",
        backdropFilter: "blur(16px)",
        borderRadius: "20px",
        boxShadow: "0 24px 48px rgba(0,0,0,0.4)",
      }}
    >
      <h1
        className="text-8xl font-black mb-2 tracking-tight"
        style={{ color: "#30A69C" }}
      >
        404
      </h1>
      <h2 className="text-2xl font-semibold mb-3" style={{ color: "#E7EBEF" }}>
        Page Not Found
      </h2>
      <p className="text-sm mb-8 text-center" style={{ color: "#94A3B8" }}>
        Sorry, we couldn't find the page you're looking for.
      </p>
      <Link
        to="/"
        className="px-6 py-3 font-semibold rounded-xl transition-all duration-200"
        aria-label="Go back to homepage"
        style={{ backgroundColor: "#30A69C", color: "#fff", textDecoration: "none" }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#228880")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#30A69C")}
      >
        Go Back Home
      </Link>
    </section>
  </main>
);

export default NotFoundPage;
